module.exports = __webpack_public_path__ + "static/media/indy-logo-small-cropped.d8c8590e.jpg";